import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { liberatedAreaReducer } from './state/liberated-area.reducers'
import { LiberatedAreaEffects } from './state/liberated-area.effects'

/**
 * Liberated Area State Module
 *
 * This module registers NgRx store and effects for Liberated Area (epodnepduos) data.
 * It's imported globally in AppModule because the data is used across multiple features:
 * - Contracts (edit, show, subcontract)
 * - Parcels (edit)
 * - Buildings (show)
 * - Non-cadastral contracts
 *
 * The actual UI component for admin/codelist/liberated-area is in LiberatedAreaModule,
 * which is lazy-loaded.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.AdminLiberatedArea, liberatedAreaReducer),
        EffectsModule.forFeature([LiberatedAreaEffects]),
    ],
})
export class LiberatedAreaStateModule {}
